import { Controller } from "stimulus";
import { isViewport } from '../assets/utils';

/**
 * Inhalt des Elements wird angezeigt, wenn der show-Viewport zutrifft
 * und der hide-Viewport nicht zutrifft.
 * 
 * Alternativ kann data-viewport-is-visible gesetzt werden. In dem Fall wird das
 * Template gerendert wenn es nicht innerhalb eines display: none Elemets liegt.
 * 
 * Wird angezeigt, wenn Viewport md oder größer:
 * <template data-controller="viewport" data-viewport-show="md">...</template>
 * 
 * Wird angezeigt wenn Viewport md oder kleiner:
 * <template data-controller="viewport" data-viewport-hide="md">...</template>
 * 
 * Wird angezeigt wenn Viewport md aber nicht xl oder kleiner:
 * <template data-controller="viewport" data-viewport-show="md" data-viewport-hide="xl">...</template>
 *
 * Wird kein Template genutzt, bleib das Element zur Anzeige unangetastet,
 * ansonsten wird es aus dem DOM gelöscht. (nicht empfohlen)
 * 
 */
export default class extends Controller {
    connect() {
        const show_viewport = this.data.get('show');
        const hide_viewport = this.data.get('hide');
        const if_visible = this.data.has('ifVisible');

        let show = true;
        if (show_viewport && !isViewport(show_viewport)) {
            show = false;
        }
        if (show && hide_viewport && !isViewport(hide_viewport)) {
            show = false;
        }
        if (show && if_visible && !this.isVisible(this.element)) {
            show = false;
        }

        if (show) {
            if (this.element.nodeName === 'TEMPLATE') {
                this.element.after(this.element.content);
                this.element.parentElement.removeChild(this.element);
            }
        } else {
            if (this.element.nodeName !== 'TEMPLATE') {
                this.element.parentElement.removeChild(this.element);
            }
        }
    }

    isVisible(element) {
        if (element.nodeName === 'TEMPLATE' && element.parentElement) {
            element = element.parentElement;
        }
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }
}